import * as formWizardConstants from './constants';
import 'element-closest-polyfill';

/**
 * Gets the closest FormWizard `form` tag associated with an element
 *
 * @param {Element} element
 */
export default function getForm(element) {
  if (!element) return;
  return element.closest(formWizardConstants.selectors.form) ||
   element.closest(formWizardConstants.selectors.leadform);
}
